<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->

<div class="row">
  <div class="col-3 pr-0 company-details-filter-sticky">
    <div class="wccard p-3 mb-1">
      <span class="text-webbtree-green f-12 font-weight-500 pointer" routerLink="/webbtree-company-list"><i
          class="fa-solid fa-arrow-left mr-1"></i> Back</span>
    </div>
    <app-person-search-filter></app-person-search-filter>
  </div>
  <div class="col-9">
    <div class="wccard p-3 mb-2">
      <div class="wccard mb-2">
      </div>
      <div class="d-flex">
        <div>
          <div class="compLogoIcon mb-2 mr-3 bg-gray-new">
            <i class="fa-solid fa-buildings text-webbtree-green" *ngIf="!companyDetails?.companylogo"></i>
            <img [src]="companyDetails?.companylogo" alt="companyDetails?.name" *ngIf="companyDetails?.companylogo">
          </div>
        </div>
        <div class="w-100">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex">
              <div class="">
                <p class="f-16 font-weight-500" *ngIf="companyname">{{companyname | titlecase}}</p>
              </div>

              <a data-testid="auto-app-company-details-a-1" target="_blank" (click)="openUrl(linkedin_url, 'linkedin')" *ngIf="linkedin_url">
                <i class="fab fa-linkedin ml-3"></i>
              </a>
              <a data-testid="auto-app-company-details-a-2" target="_blank" (click)="openUrl(twitter_url, 'twitter')" *ngIf="twitter_url">
                <i class="fa-brands fa-square-x-twitter ml-2"></i>
              </a>
              <a data-testid="auto-app-company-details-a-3" target="_blank" (click)="openUrl(facebook_url, 'facebook')" *ngIf="facebook_url">
                <i class="fab fa-facebook ml-2"></i>
              </a>
            <a data-testid="auto-app-company-details-a-4" target="_blank" (click)="openUrl(companyDetails?.website, 'website')" *ngIf="companyDetails?.website">
              <i class="fas fa-globe text-webbtree-green ml-2"></i>
            </a>
            </div>
            <div>
              <button data-testid="auto-app-company-details-button-1" class="btn-trms-regular"  (click)="scrollTOCompareCompany(companyDetails)">
                Compare
              </button>
            </div>
          </div>
          <div>
            <p class="f-12 text-black mb-1" *ngIf="companyDetails?.industry">{{companyDetails?.industry | titlecase}}
            </p>
            <div class="text-9696 f-12 d-flex align-items-center mb-2">
              <span matTooltip="Founded On" [matTooltipClass]="{ 'red-tooltip text-black': true }"
                *ngIf="companyDetails?.founded"><i class="fa-regular fa-flag mr-2"></i>
                <span>{{companyDetails?.founded}}</span></span>
              <i class="fa-solid fa-circle mx-2" style="font-size:3px; color: #d9d9d9;"
                *ngIf="companyDetails?.founded && companyDetails?.location?.name"></i>
              <span matTooltip="Location" [matTooltipClass]="{ 'red-tooltip text-black': true }"
                *ngIf="companyDetails?.location?.name"><i class="fa-regular fa-buildings mr-2"></i>
                <span>{{companyDetails?.location?.name | titlecase}}</span></span>
              <i class="fa-solid fa-circle mx-2" style="font-size:3px; color: #d9d9d9;"
                *ngIf="companyDetails?.size && companyDetails?.location?.name"></i>
              <span matTooltip="Company Size" [matTooltipClass]="{ 'red-tooltip text-black': true }"
                *ngIf="companyDetails?.size"><i class="fa-regular fa-users mr-2"></i>
                <span>{{companyDetails?.size}}</span></span>
            </div>
            <div class="d-flex justify-content-between" *ngIf="companyDetails?.summary">
              <div class="textBox f-12" [class.viewMore]="viewMore">
                <p>{{companyDetails?.summary?.charAt(0).toUpperCase()}}{{companyDetails?.summary?.slice(1)}}</p>
              </div>
              <div *ngIf="companyDetails?.summary && companyDetails?.summary?.length > 190">
                <div class="f-10 text-webbtree-green text-right pointer" style="width: 90px;"
                  (click)="viewMore = !viewMore">{{ viewMore ? 'View less': 'View More' }} <i
                    class="far f-10 font-weight-500" [ngClass]="viewMore ? 'fa-angle-up': 'fa-angle-down'"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="HR-seperator-in-card">
      <div class="d-flex">
        <div>
          <div class="d-block" style="width: 75px;"></div>
        </div>
        <div class="d-flex justify-content-between w-100">
          <div #tta class="textBox2 d-flex flex-wrap" style="row-gap: 10px; column-gap: 10px;"
            [class.viewMore2]="viewMore2">
            <span *ngFor="let tag of tags" class="tagslabel pb-0 mb-0 mr-0">
              <span class="tagicon"><i class="fas fa-tag"></i></span>
              <span class="d-grid" style="margin-bottom: 2px;"> <span [matTooltip]="tag"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }" class="text-truncate">{{ tag | titlecase
                  }}</span></span>
            </span>
          </div>
          <div>
            <div *ngIf="tta.scrollHeight > 25" class="f-10 text-webbtree-green text-right pointer" style="width: 90px;"
              (click)="viewMore2 = !viewMore2">{{ viewMore2 ? 'View less': 'View More' }} <i
                class="far f-10 font-weight-500" [ngClass]="viewMore2 ? 'fa-angle-up': 'fa-angle-down'"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wccard mb-2 company-details-tabs" *ngIf="companyDetails">
      <ul class="nav nav-pills mb-0" id="pills-tab" role="tablist">
        <a data-testid="auto-app-company-details-a-5" class="nav-link" routerLinkActive="active" routerLink="overview">
          Overview
        </a>
        <a data-testid="auto-app-company-details-a-6" class="nav-link" routerLinkActive="active" routerLink="location">
          Location
        </a>
        <a data-testid="auto-app-company-details-a-7" class="nav-link" routerLinkActive="active" routerLink="attrition">
          Attrition and Hiring
        </a>
        <a data-testid="auto-app-company-details-a-8" class="nav-link" routerLinkActive="active" routerLink="education">
          Education
        </a>
        <a data-testid="auto-app-company-details-a-9" class="nav-link" routerLinkActive="active" routerLink="skills">
          Skills
        </a>
        <a data-testid="auto-app-company-details-a-10" class="nav-link" routerLinkActive="active" routerLink="titles">
          Titles
        </a>
        <a data-testid="auto-app-company-details-a-11" class="nav-link" routerLinkActive="active" routerLink="talent-movement">
          Talent Movement
        </a>
        <a data-testid="auto-app-company-details-a-12" class="nav-link" routerLinkActive="active" routerLink="profile">
          Profile
        </a>
        <a data-testid="auto-app-company-details-a-13" class="nav-link" routerLinkActive="active" routerLink="diversity">
          Diversity
        </a>
         <a data-testid="auto-app-company-details-a-14" class="nav-link" routerLinkActive="active" routerLink="similar-companies">
          Similar Companies
        </a>
      </ul>
    </div>

    <div class="tab-content" *ngIf="companyDetails">
      <div class="tab-pane fade show active">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
